export default "__VITE_ASSET__C$2L4EeS__"